// Story 8.12 (ADO-2021, D-6/D-7) — the "already on order" pill (Figma Cart Row 4977:1802): a
// truck, then bold blue text such as "On order 10/02/2026 · ETA 18/02/2026". The same chip is used
// on the product card and on the order review row so the surfaces read alike. The truck is
// decorative, so the chip's accessible text is exactly its visible text. The cart side panel rows
// (Figma Cart Drawer Row 5008:41020) show the same text.

import type { OnOrderProduct } from '../api/on-order.client';
import { Icon } from '../design-system';
import { onOrderChipText } from './onOrderDisplay';
import styles from './OnOrderChip.module.css';

export interface OnOrderChipProps {
  readonly product: OnOrderProduct;
  /** A CSS-module class, which is `string | undefined` under `noUncheckedIndexedAccess`. */
  readonly className?: string | undefined;
}

export function OnOrderChip({ product, className }: OnOrderChipProps) {
  const text = onOrderChipText(product);
  if (text === '') return null;
  return (
    <span
      className={className === undefined ? styles.chip : `${styles.chip} ${className}`}
      data-on-order-chip=""
    >
      <Icon name="truck" size={14} className={styles.icon} />
      <span className={styles.text}>{text}</span>
    </span>
  );
}
